import type { BookTimelineLayout } from "../../../book/BookLayout";
import type { ChapterBoard } from "../../ChapterBoard/types";
import { characterGroupsAtPlayhead } from "../../../character/ActiveCharacterGroup/atPlayhead";
import { characterGroupMeasurable } from "../ActiveCharacterGroup/measurables";
import { ensureBoardModelDebugFrame } from "../host";
import type { BoardModelDebugMeasureContext } from "../measurable";
import {
  ensureBoardModelDebugLabelHost,
  hideStaleBoardModelDebugLabels,
} from "../labelHost";
import {
  type EnsureDebugFrame,
  syncBoardModelDebugFrame,
} from "../sync";

const HOST_SELECTOR = "[data-character-group-debug-host]";
const GROUP_MODEL = "CharacterGroup";

export function updateCharacterGroupDebugFrames(
  root: HTMLElement,
  board: ChapterBoard,
  layout: BookTimelineLayout,
  playheadMs: number,
  enabled: boolean,
): void {
  const host = root.querySelector<HTMLElement>(HOST_SELECTOR);
  const locationsRoot = root.parentElement?.querySelector<HTMLElement>(
    ".timeline-locations",
  );
  const world = root.parentElement;
  if (host === null || locationsRoot == null || world === null) {
    return;
  }
  const frames = host.querySelectorAll<HTMLElement>(
    `[data-board-model="${GROUP_MODEL}"]`,
  );
  const labelHost = ensureBoardModelDebugLabelHost(world);
  if (!enabled) {
    for (const frame of frames) {
      frame.style.display = "none";
    }
    hideStaleBoardModelDebugLabels(labelHost, GROUP_MODEL, new Set());
    return;
  }
  const context: BoardModelDebugMeasureContext = {
    world,
    labelHost,
    labelsRoot: root,
    locationsRoot,
    layout,
    playheadMs,
  };
  const groups = characterGroupsAtPlayhead(board.rail, playheadMs);
  const activeIds = new Set(groups.map((group) => group.id));
  for (const frame of frames) {
    if (!activeIds.has(frame.dataset.boardId ?? "")) {
      frame.style.display = "none";
    }
  }
  const ensureFrame: EnsureDebugFrame = (
    frameHost,
    model,
    id,
  ) => ensureBoardModelDebugFrame(frameHost, model, id);
  for (const group of groups) {
    if (group.markerIds.length === 0) {
      continue;
    }
    syncBoardModelDebugFrame(
      host,
      ensureFrame,
      characterGroupMeasurable(group.id, group.markerIds),
      context,
    );
  }
  hideStaleBoardModelDebugLabels(labelHost, GROUP_MODEL, activeIds);
}
